import React from "react";

export const GetHora = (menosMasHora = 0, menosMasMinuto = 0)=>{
 // Obtener la fecha y hora actual
 const now = new Date();

 // Modificar la hora y los minutos si se pasan valores
 if (menosMasHora) {
     now.setHours(now.getHours() + menosMasHora);
 }
 if (menosMasMinuto) {
     now.setMinutes(now.getMinutes() + menosMasMinuto);
 }

 // Extraer año, mes, día, hora, minutos y segundos
 const year = now.getFullYear();
 const month = String(now.getMonth() + 1).padStart(2, '0'); // Meses son 0-indexados
 const day = String(now.getDate()).padStart(2, '0');
 const hours = String(now.getHours()).padStart(2, '0');
 const minutes = String(now.getMinutes()).padStart(2, '0');
 const seconds = String(now.getSeconds()).padStart(2, '0');

 // Formatear la fecha en el formato yyyy-MM-dd HH:mm:ss
 const formattedDate = `'${year}-${month}-${day} ${hours}:${minutes}:${seconds}'`;

 return formattedDate;
}
// export default useGetHora
